import { inject, Injectable } from '@angular/core';
import { DefaultMissingHandler, TranslocoMissingHandler, TranslocoMissingHandlerData } from '@jsverse/transloco';
import { PostHogService } from '@rma/generic/util/posthog';

@Injectable()
export class PostHogTranslationMissingHandler implements TranslocoMissingHandler {
  private readonly posthogService = inject(PostHogService);
  // Delegated by instance because DefaultMissingHandler has no providedIn and so cannot be injected.
  private readonly defaultHandler = new DefaultMissingHandler();
  // In memory so a fresh page load reports again.
  private readonly reported = new Set<string>();

  public handle(key: string, data: TranslocoMissingHandlerData): string {
    const entry = `${data.activeLang}:${key}`;

    // Marked only once PostHog can send it, so a key missed before the initialiser runs is retried on a later miss.
    if (this.posthogService.client && !this.reported.has(entry)) {
      this.reported.add(entry);
      this.posthogService.capture('translation_missing', { key, lang: data.activeLang });
    }

    return this.defaultHandler.handle(key, data);
  }
}
